import React from 'react';
import { SparkIcon, Text, TooltipTrigger } from '@spark';

/**
 * Horizontal strip showing expected performance configuration:
 * median latency, throughput, memory, concurrency, processor.
 */
const PerformanceInfoBar = ({ performanceInfo }) => {
    const {
        medianLatencyMs,
        expectedThroughputRps,
        memoryAllocationGb,
        concurrencyRequests,
        processorVcpu,
    } = performanceInfo || {};

    return (
        <div className="inference-info-bar">
            <div className="inference-info-bar__title">
                <Text variant="base-semibold" color="primary">Expected performance</Text>
                <TooltipTrigger text="Expected performance based on your current deployment configuration">
                    <SparkIcon slug="circle-help" size="small" />
                </TooltipTrigger>
            </div>

            <div className="inference-info-bar__metric">
                <span className="inference-info-bar__label">Median latency:</span>
                <span className="inference-info-bar__value">{medianLatencyMs} ms</span>
            </div>

            <div className="inference-info-bar__metric">
                <span className="inference-info-bar__label">Expected throughput:</span>
                <span className="inference-info-bar__value">{expectedThroughputRps} RPS</span>
            </div>

            <div className="inference-info-bar__metric">
                <span className="inference-info-bar__label">Memory allocation:</span>
                <span className="inference-info-bar__value">{memoryAllocationGb} GB</span>
            </div>

            <div className="inference-info-bar__metric">
                <span className="inference-info-bar__label">Concurrency</span>
                <span className="inference-info-bar__value">{concurrencyRequests} request</span>
            </div>

            <div className="inference-info-bar__metric">
                <span className="inference-info-bar__label">Processor:</span>
                <span className="inference-info-bar__value">{processorVcpu} vCPU</span>
            </div>
        </div>
    );
};

export default PerformanceInfoBar;
